import { setSubroute } from 'store/navbar'
import { injectReducers } from 'store/reducers'
import { setPageTitle } from 'utils/misc'
import { UserIsAuthenticated, UserHasValidPassword, UserHasRole } from 'containers/authContainers'
import { USER_ROLES_CAN_ACCESS_STUDY_TIMELINE } from 'utils/constants'
import StudyTimelinePageContainer from './routes/StudyTimelinePage/containers/StudyTimelinePageContainer'
import studyTimelineReducer from './routes/StudyTimelinePage/modules/StudyTimeline'

export default store => {
  return {
    path: 'study-timeline',
    exact: true,
    getIndexRoute(location, cb) {
      const { params } = location || {}
      const { studyID } = params || {}
      const studyIDSafe = studyID != null ? studyID : null
      const { currentStudy } = store.getState().study

      store.dispatch(setSubroute('studyTimeline'))
      injectReducers(store, { studyTimeline: studyTimelineReducer })
      setPageTitle(`Study Timeline | Study ${studyIDSafe} | ${currentStudy?.platform_name ?? ''}`)

      // React Router v3 getIndexRoute expects a route object { component }, not a raw component
      const IndexComponent = UserIsAuthenticated(
        UserHasValidPassword(
          UserHasRole(USER_ROLES_CAN_ACCESS_STUDY_TIMELINE, studyIDSafe, StudyTimelinePageContainer),
        ),
      )
      cb(null, { component: IndexComponent })
    },
  }
}

